import { NgModule, Pipe, ModuleWithProviders, Provider, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthorizationConfig } from './privilege-authorization.modal';
import { PrevilegeAuthorizationDirective } from './directives/privilege-authorization.directive';


@NgModule({
    imports: [
        CommonModule,
        PrevilegeAuthorizationDirective,
    ],
    exports: [PrevilegeAuthorizationDirective],
})
  export class PrevilegeAuthorizationModule {
    constructor () {}
    static forRoot(previlegeConfig: AuthorizationConfig): ModuleWithProviders<unknown> {
        return {
          ngModule: PrevilegeAuthorizationModule,
          providers: [
            {provide: AuthorizationConfig, useValue: previlegeConfig }
          ]
        };
      }
}
